/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_PAYMENT_METHODS = '[Payment] Get Payment Methods',
  GET_PAYMENT_METHODS_SUCCESS = '[Payment] Get Payment Methods Success',
  GET_PAYMENT_METHODS_FAILED = '[Payment] Get Payment Methods Failed',

  CREATE_PAYMENT_METHODS = '[Payment] Create Payment Methods',
  CREATE_PAYMENT_METHODS_SUCCESS = '[Payment] Create Payment Methods Success',
  CREATE_PAYMENT_METHODS_FAILED = '[Payment] Create Payment Methods Failed',

  UPDATE_PAYMENT_METHODS = '[Payment] Update Payment Methods',
  UPDATE_PAYMENT_METHODS_SUCCESS = '[Payment] Update Payment Methods Success',
  UPDATE_PAYMENT_METHODS_FAILED = '[Payment] Update Payment Methods Failed',

  GET_PAYMENT_SCHEMES = '[Payment] Get Payment Schemes',
  GET_PAYMENT_SCHEMES_SUCCESS = '[Payment] Get Payment Schemes Success',
  GET_PAYMENT_SCHEMES_FAILED = '[Payment] Get Payment Schemes Failed',

  CREATE_PAYMENT_SCHEMES = '[Payment] Create Payment Schemes',
  CREATE_PAYMENT_SCHEMES_SUCCESS = '[Payment] Create Payment Schemes Success',
  CREATE_PAYMENT_SCHEMES_FAILED = '[Payment] Create Payment Schemes Failed',

  UPDATE_PAYMENT_SCHEMES = '[Payment] Update Payment Schemes',
  UPDATE_PAYMENT_SCHEMES_SUCCESS = '[Payment] Update Payment Schemes Success',
  UPDATE_PAYMENT_SCHEMES_FAILED = '[Payment] Update Payment Schemes Failed',

  GET_PAYMENT_SCHEME_DETAILS = '[Payment] Get Payment Schemes',
  GET_PAYMENT_SCHEME_DETAILS_SUCCESS = '[Payment] Get Payment Schemes Success',
  GET_PAYMENT_SCHEME_DETAILS_FAILED = '[Payment] Get Payment Schemes Failed',

  CREATE_PAYMENT_SCHEME_DETAILS = '[Payment] Create Payment Schemes',
  CREATE_PAYMENT_SCHEME_DETAILS_SUCCESS = '[Payment] Create Payment Schemes Success',
  CREATE_PAYMENT_SCHEME_DETAILS_FAILED = '[Payment] Create Payment Schemes Failed',

  UPDATE_PAYMENT_SCHEME_DETAILS = '[Payment] Update Payment Schemes',
  UPDATE_PAYMENT_SCHEME_DETAILS_SUCCESS = '[Payment] Update Payment Schemes Success',
  UPDATE_PAYMENT_SCHEME_DETAILS_FAILED = '[Payment] Update Payment Schemes Failed',

  GET_PAYMENT_TERMS = '[Payment] Get Payment Terms',
  GET_PAYMENT_TERMS_SUCCESS = '[Payment] Get Payment Terms Success',
  GET_PAYMENT_TERMS_FAILED = '[Payment] Get Payment Terms Failed',

  CREATE_PAYMENT_TERMS = '[Payment] Create Payment Terms',
  CREATE_PAYMENT_TERMS_SUCCESS = '[Payment] Create Payment Terms Success',
  CREATE_PAYMENT_TERMS_FAILED = '[Payment] Create Payment Terms Failed',

  UPDATE_PAYMENT_TERMS = '[Payment] Update Payment Terms',
  UPDATE_PAYMENT_TERMS_SUCCESS = '[Payment] Update Payment Terms Success',
  UPDATE_PAYMENT_TERMS_FAILED = '[Payment] Update Payment Terms Failed',

  GET_PAYMENT_TYPES = '[Payment] Get Payment Types',
  GET_PAYMENT_TYPES_SUCCESS = '[Payment] Get Payment Types Success',
  GET_PAYMENT_TYPES_FAILED = '[Payment] Get Payment Types Failed',

  CREATE_PAYMENT_TYPES = '[Payment] Create Payment Types',
  CREATE_PAYMENT_TYPES_SUCCESS = '[Payment] Create Payment Types Success',
  CREATE_PAYMENT_TYPES_FAILED = '[Payment] Create Payment Types Failed',

  UPDATE_PAYMENT_TYPES = '[Payment] Update Payment Types',
  UPDATE_PAYMENT_TYPES_SUCCESS = '[Payment] Update Payment Types Success',
  UPDATE_PAYMENT_TYPES_FAILED = '[Payment] Update Payment Types Failed',

  SELECT_PAYMENT_SCHEME = '[Payment] Select Payment Scheme',

  CHOOSE_PAYMENT_SCHEME = '[Payment] Choose Payment Scheme',
  CHOOSE_PAYMENT_SCHEME_SUCCESS = '[Payment] Choose Payment Scheme Success',
  CHOOSE_PAYMENT_SCHEME_FAILED = '[Payment] Choose Payment Scheme Failed',

  PREVIEW_PAYMENT_SCHEME = '[Payment] Preview Payment Scheme',
  PREVIEW_PAYMENT_SCHEME_SUCCESS = '[Payment] Preview Payment Scheme Success',
  PREVIEW_PAYMENT_SCHEME_FAILED = '[Payment] Preview Payment Scheme Failed',

  GET_STUDENT_PAYMENT_BALANCE = '[Payment] Get Student Payment Balance',
  GET_STUDENT_PAYMENT_BALANCE_SUCCESS = '[Payment] Get Student Payment Balance Success',
  GET_STUDENT_PAYMENT_BALANCE_FAILED = '[Payment] Get Student Payment Balance Failed',

  UPLOAD_PAYMENT = '[Payment] Upload Payment',
  UPLOAD_PAYMENT_SUCCESS = '[Payment] Upload Payment Success',
  UPLOAD_PAYMENT_FAILED = '[Payment] Upload Payment Failed',

  GET_PAYMENT_LIST = '[Payment] Get Payment List',
  GET_PAYMENT_LIST_SUCCESS = '[Payment] Get Payment List Success',
  GET_PAYMENT_LIST_FAILED = '[Payment] Get Payment List Failed',

  APPROVE_PAYMENT = '[Payment] Approve Payment',
  APPROVE_PAYMENT_SUCCESS = '[Payment] Approve Payment Success',
  APPROVE_PAYMENT_FAILED = '[Payment] Approve Payment Failed',
}

// PAYMENT METHOD ACTIONS
export const getPaymentMethods = createAction(
  ActionTypes.GET_PAYMENT_METHODS
);

export const getPaymentMethodsSuccess = createAction(
	ActionTypes.GET_PAYMENT_METHODS_SUCCESS,
  props<{ data: any }>()
);

export const getPaymentMethodsFailed = createAction(
  ActionTypes.GET_PAYMENT_METHODS_FAILED,
  props<{ data: any }>()
);

export const createPaymentMethods = createAction(
  ActionTypes.CREATE_PAYMENT_METHODS,
  props<{ data: any }>()
);

export const createPaymentMethodsSuccess = createAction(
	ActionTypes.CREATE_PAYMENT_METHODS_SUCCESS,
  props<{ data: any }>()
);

export const createPaymentMethodsFailed = createAction(
  ActionTypes.CREATE_PAYMENT_METHODS_FAILED,
  props<{ data: any }>()
);

export const updatePaymentMethods = createAction(
  ActionTypes.UPDATE_PAYMENT_METHODS,
  props<{ data: any, paymentId: any }>()
);

export const updatePaymentMethodsSuccess = createAction(
	ActionTypes.UPDATE_PAYMENT_METHODS_SUCCESS,
  props<{ data: any }>()
);

export const UPDATE_PAYMENT_METHODS_FAILED = createAction(
  ActionTypes.UPDATE_PAYMENT_METHODS_FAILED,
  props<{ data: any }>()
);

// PAYMENT SCHEMES ACTIONS
export const getPaymentSchemes = createAction(
  ActionTypes.GET_PAYMENT_SCHEMES
);

export const getPaymentSchemesSuccess = createAction(
	ActionTypes.GET_PAYMENT_SCHEMES_SUCCESS,
  props<{ data: any }>()
);

export const getPaymentSchemesFailed = createAction(
  ActionTypes.GET_PAYMENT_SCHEMES_FAILED,
  props<{ data: any }>()
);

export const createPaymentSchemes = createAction(
  ActionTypes.CREATE_PAYMENT_SCHEMES,
  props<{ data: any }>()
);

export const createPaymentSchemesSuccess = createAction(
	ActionTypes.CREATE_PAYMENT_SCHEMES_FAILED,
  props<{ data: any }>()
);

export const createPaymentSchemesFailed = createAction(
  ActionTypes.CREATE_PAYMENT_SCHEMES_FAILED,
  props<{ data: any }>()
);

export const updatePaymentSchemes = createAction(
  ActionTypes.UPDATE_PAYMENT_SCHEMES,
  props<{ data: any, paymentSchemeId: any }>()
);

export const updatePaymentSchemesSuccess = createAction(
	ActionTypes.UPDATE_PAYMENT_SCHEMES_SUCCESS,
  props<{ data: any }>()
);

export const updatePaymentSchemesFailed = createAction(
  ActionTypes.UPDATE_PAYMENT_SCHEMES_FAILED,
  props<{ data: any }>()
);

// PAYMENT SCHEME DETAILS ACTIONS
export const getPaymentSchemeDetails = createAction(
  ActionTypes.GET_PAYMENT_SCHEME_DETAILS
);

export const getPaymentSchemeDetailsSuccess = createAction(
	ActionTypes.GET_PAYMENT_SCHEME_DETAILS_SUCCESS,
  props<{ data: any }>()
);

export const getPaymentSchemeDetailsFailed = createAction(
  ActionTypes.GET_PAYMENT_SCHEME_DETAILS_FAILED,
  props<{ data: any }>()
);

export const createPaymentSchemeDetails = createAction(
  ActionTypes.CREATE_PAYMENT_SCHEME_DETAILS,
  props<{ data: any }>()
);

export const createPaymentSchemeDetailsSuccess = createAction(
	ActionTypes.CREATE_PAYMENT_SCHEME_DETAILS_SUCCESS,
  props<{ data: any }>()
);

export const createPaymentSchemeDetailsFailed = createAction(
  ActionTypes.CREATE_PAYMENT_SCHEME_DETAILS_FAILED,
  props<{ data: any }>()
);

export const updatePaymentSchemeDetails = createAction(
  ActionTypes.UPDATE_PAYMENT_SCHEME_DETAILS,
  props<{ data: any, paymentSchemeDetailsId: any }>()
);

export const updatePaymentSchemeDetailsSuccess = createAction(
	ActionTypes.UPDATE_PAYMENT_SCHEME_DETAILS_SUCCESS,
  props<{ data: any }>()
);

export const updatePaymentSchemeDetailsFailed = createAction(
  ActionTypes.UPDATE_PAYMENT_SCHEME_DETAILS_FAILED,
  props<{ data: any }>()
);

// PAYMENT TERMS ACTIONS
export const getPaymentTerms = createAction(
  ActionTypes.GET_PAYMENT_TERMS
);

export const getPaymentTermsSuccess = createAction(
	ActionTypes.GET_PAYMENT_TERMS_SUCCESS,
  props<{ data: any }>()
);

export const getPaymentTermsFailed = createAction(
  ActionTypes.GET_PAYMENT_TERMS_FAILED,
  props<{ data: any }>()
);

export const createPaymentTerms = createAction(
  ActionTypes.CREATE_PAYMENT_TERMS,
  props<{ data: any }>()
);

export const createPaymentTermsSuccess = createAction(
	ActionTypes.CREATE_PAYMENT_TERMS_SUCCESS,
  props<{ data: any }>()
);

export const createPaymentTermsFailed = createAction(
  ActionTypes.CREATE_PAYMENT_TERMS_FAILED,
  props<{ data: any }>()
);

export const updatePaymentTerms = createAction(
  ActionTypes.UPDATE_PAYMENT_TERMS,
  props<{ data: any, paymentTermId: any }>()
);

export const updatePaymentTermsSuccess = createAction(
	ActionTypes.UPDATE_PAYMENT_TERMS_SUCCESS,
  props<{ data: any }>()
);

export const updatePaymentTermsFailed = createAction(
  ActionTypes.UPDATE_PAYMENT_TERMS_FAILED,
  props<{ data: any }>()
);

// COURSES ACTIONS
export const getPaymentTypes = createAction(
  ActionTypes.GET_PAYMENT_TYPES
);

export const getPaymentTypesSuccess = createAction(
	ActionTypes.GET_PAYMENT_TYPES_SUCCESS,
  props<{ data: any }>()
);

export const getPaymentTypesFailed = createAction(
  ActionTypes.GET_PAYMENT_TYPES_FAILED,
  props<{ data: any }>()
);

export const createPaymentTypes = createAction(
  ActionTypes.CREATE_PAYMENT_TYPES,
  props<{ data: any }>()
);

export const createPaymentTypesSuccess = createAction(
	ActionTypes.CREATE_PAYMENT_TYPES_SUCCESS,
  props<{ data: any }>()
);

export const createPaymentTypesFailed = createAction(
  ActionTypes.CREATE_PAYMENT_TYPES_FAILED,
  props<{ data: any }>()
);

export const updatePaymentTypes = createAction(
  ActionTypes.UPDATE_PAYMENT_TYPES,
  props<{ data: any, paymentTypeId: any }>()
);

export const updatePaymentTypesSuccess = createAction(
	ActionTypes.UPDATE_PAYMENT_TYPES_SUCCESS,
  props<{ data: any }>()
);

export const updatePaymentTypesFailed = createAction(
  ActionTypes.UPDATE_PAYMENT_TYPES_FAILED,
  props<{ data: any }>()
);

export const selectPaymentScheme = createAction(
  ActionTypes.SELECT_PAYMENT_SCHEME,
  props<{ data: any }>()
);

export const choosePaymentScheme = createAction(
  ActionTypes.CHOOSE_PAYMENT_SCHEME,
  props<{ assessment_id: any, data: any, student_id }>()
);

export const choosePaymentSchemeSuccess = createAction(
	ActionTypes.CHOOSE_PAYMENT_SCHEME_SUCCESS,
  props<{ assessment_id: any, data: any, student_id: any }>()
);

export const choosePaymentSchemeFailed = createAction(
  ActionTypes.CHOOSE_PAYMENT_SCHEME_FAILED,
  props<{ data: any }>()
);

export const previewPaymentScheme = createAction(
  ActionTypes.PREVIEW_PAYMENT_SCHEME,
  props<{ assessment_id: any, data: any }>()
);

export const previewPaymentSchemeSuccess = createAction(
	ActionTypes.PREVIEW_PAYMENT_SCHEME_SUCCESS,
  props<{ assessment_id: any, data: any }>()
);

export const previewPaymentSchemeFailed = createAction(
  ActionTypes.PREVIEW_PAYMENT_SCHEME_FAILED,
  props<{ data: any }>()
);

export const getStudentPaymentBalance = createAction(
  ActionTypes.GET_STUDENT_PAYMENT_BALANCE,
  props<{ student_id: any, assessment_id: any, redirect: Boolean }>()
);

export const getStudentPaymentBalanceSuccess = createAction(
	ActionTypes.GET_STUDENT_PAYMENT_BALANCE_SUCCESS,
  props<{ data: any, redirect: Boolean }>()
);

export const getStudentPaymentBalanceFailed = createAction(
  ActionTypes.GET_STUDENT_PAYMENT_BALANCE_FAILED,
  props<{ data: any }>()
);

export const uploadPayment = createAction(
  ActionTypes.UPLOAD_PAYMENT,
  props<{ assessment_id: any, data: any }>()
);

export const uploadPaymentSuccess = createAction(
	ActionTypes.UPLOAD_PAYMENT_SUCCESS,
  props<{ assessment_id: any, data: any }>()
);

export const uploadPaymentFailed = createAction(
  ActionTypes.UPLOAD_PAYMENT_FAILED,
  props<{ data: any }>()
);

export const getPaymentList = createAction(
  ActionTypes.GET_PAYMENT_LIST,
  props<{ data: any }>()
);

export const getPaymentListSuccess = createAction(
	ActionTypes.GET_PAYMENT_LIST_SUCCESS,
  props<{ data: any }>()
);

export const getPaymentListFailed = createAction(
  ActionTypes.GET_PAYMENT_LIST_FAILED,
  props<{ data: any }>()
);

export const approvePayment = createAction(
  ActionTypes.APPROVE_PAYMENT,
  props<{ studentPayment_id:any, data: any }>()
);

export const approvePaymentSuccess = createAction(
	ActionTypes.APPROVE_PAYMENT_SUCCESS,
  props<{ data: any }>()
);

export const approvePaymentFailed = createAction(
  ActionTypes.APPROVE_PAYMENT_FAILED,
  props<{ data: any }>()
);